/**
 * ЕДИНЫЙ флаг отладки (STEP8 эт.2, постановка Антона 16:22).
 *
 * Постановка: «спрятать до конца отладки, потом убрать, чтоб и в консоли
 * светилось по минимуму». Значит:
 *  - в ленте по умолчанию НЕ показывать идентификаторы событий, коды,
 *    служебные поля;
 *  - подробные console.info — только под этим флагом;
 *  - один переключатель, а не рассыпанные по файлам if'ы.
 *
 * Почему НЕ process.env.NODE_ENV: отладка нужна и в продакшене на стенде,
 * а NODE_ENV там "production" и логи бы пропали. localStorage позволяет
 * включить диагностику на живом стенде без пересборки.
 *
 * Почему НЕ просто boolean в коде: Антон просил «потом убрать, чтоб и в
 * консоли светилось по минимуму» — значит флаг должен быть снимаемым
 * одной правкой, а не охотой по проекту.
 */

/**
 * true — показывать техническую информацию в ленте и подробные логи.
 *
 * Читается из localStorage при загрузке. Ключ намеренно короткий и
 * без префикса приложения: его проще набрать в консоли браузера.
 * По умолчанию false (постановка: «не показывать»).
 */
export const DEBUG = typeof localStorage !== "undefined" && localStorage.getItem("algDebug") === "1";

/**
 * Подробный лог под флагом отладки. Использовать вместо console.info
 * для диагностических сообщений, которые в релизе не нужны.
 *
 * Текст логов НЕ менять: по ним ищут в бандле (страж перед выкладкой).
 * Меняется только обёртка — вызов под флагом, а не безусловный.
 */
export function debugLog(...args: unknown[]): void {
  if (DEBUG) console.info(...args);
}

/**
 * Подробный лог под флагом отладки (console.log). Для замерных строк,
 * которые должны быть видны при отладке, но не в релизе.
 */
export function debugLogL(...args: unknown[]): void {
  if (DEBUG) console.log(...args);
}
